<!--This is PDF template for pdf download and pdf package not supported classes for styles for inline css added-->
<!doctype html>
<html lang="en">
  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"5%"}'>
          <img
            [src]="printData?.logo"
            alt="Organization Logo"
            style="width: 100px; height: auto; object-fit: contain" />
        </div>

        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ printData?.orgDetail?.address || '' }}
          </div>
          <div class="address" style="text-align: right">
            {{ printData?.orgDetail?.city || '' }},
            {{ printData?.orgDetail?.state || '' }},
            {{ printData?.orgDetail?.country || '' }} ,
            {{ printData?.orgDetail?.zipCode || '' }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.caseDetail?.student?.firstName || '' }}
          {{ printData?.caseDetail?.student?.lastName || '' }}
        </div>
        <div style="width: auto"></div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.caseDetail?.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b> {{ printData?.caseDetail?.student?.gender || '' }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.caseDetail?.student?.organizationName || '' }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.caseDetail?.student?.dateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div style="text-align: center; margin: 10px 0">
        <div class="datalabel" style="font-size: 16px; font-weight: bold">
          Student Self Assessment Questions
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <br />
      <div
        style="width: auto"
        *ngIf="
          printData &&
          printData.questionList &&
          printData.questionList.length > 0
        ">
        <ng-container *ngFor="let que of printData.questionList; let i = index">
          <div class="questionContainer" style="margin-bottom: 8px">
            <b class="questionText">
              <span class="stepIndicator"
                >{{ i + 1 }}/{{ printData.questionList.length || 0 }}</span
              >
              {{ que.question }}
            </b>

            <div
              *ngIf="
                que &&
                que.questionType === 'scale' &&
                que.scaleOptions &&
                que.scaleOptions.length > 0
              "
              [attr.data-pdfmake]="generateOptionsRow(que.scaleOptions)"></div>

            <div
              *ngIf="que && que.questionType === 'text'"
              [attr.data-pdfmake]="generateTextBox()"></div>
          </div>
        </ng-container>
      </div>
    </div>
  </body>
</html>
